<div class="w-full mx-auto h-screen p-5">
    <h1 class="text-2xl font-bold mb-4">{{ isEditing ? 'Editar' : 'Crear Nuevo' }} Banco</h1>
    
    <!-- Información sobre campos obligatorios -->
    <div class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded-r-md">
        <div class="flex">
            <div class="ml-3">
                <p class="text-sm text-blue-700">
                    <strong>Campos obligatorios:</strong> Nombre del Banco, Número de Cuenta y Tipo de Cuenta.
                    <br>Los demás campos son opcionales y pueden completarse posteriormente.
                </p>
            </div>
        </div>
    </div>

    <form [formGroup]="bankForm" (ngSubmit)="onSubmit()">
        <!-- Campos Obligatorios -->
        <div class="mb-4 flex flex-col gap-6 xl:flex-row">
            <!-- Nombre del Banco -->
            <div class="w-full xl:w-1/2">
                <label for="bankName" class="block text-gray-700 font-bold mb-2" appRequiredLabel>
                    Nombre del Banco
                </label>
                <input
                    type="text"
                    id="bankName"
                    formControlName="bankName"
                    class="w-full px-3 py-2 border rounded-md"
                    [ngClass]="{'border-red-500': hasError('bankName', 'required') || hasError('bankName', 'minlength')}"
                >
                <div class="text-red-500 text-sm mt-1" *ngIf="hasError('bankName', 'required')">
                    El nombre del banco es obligatorio
                </div>
                <div class="text-red-500 text-sm mt-1" *ngIf="hasError('bankName', 'minlength')">
                    El nombre debe tener al menos 3 caracteres
                </div>
            </div>

            <!-- Número de Cuenta -->
            <div class="w-full xl:w-1/2">
                <label for="accountNumber" class="block text-gray-700 font-bold mb-2" appRequiredLabel>
                    Número de Cuenta
                </label>
                <input
                    type="text"
                    id="accountNumber"
                    formControlName="accountNumber"
                    class="w-full px-3 py-2 border rounded-md"
                    [ngClass]="{'border-red-500': hasError('accountNumber', 'required') || hasError('accountNumber', 'minlength')}"
                >
                <div class="text-red-500 text-sm mt-1" *ngIf="hasError('accountNumber', 'required')">
                    El número de cuenta es obligatorio
                </div>
                <div class="text-red-500 text-sm mt-1" *ngIf="hasError('accountNumber', 'minlength')">
                    El número de cuenta debe tener al menos 5 caracteres
                </div>
            </div>
        </div>

        <div class="mb-4 flex flex-col gap-6 xl:flex-row">
            <!-- Tipo de Cuenta -->
            <div class="w-full xl:w-1/2">
                <label for="accountType" class="block text-gray-700 font-bold mb-2" appRequiredLabel>
                    Tipo de Cuenta
                </label>
                <select
                    id="accountType"
                    formControlName="accountType"
                    class="w-full px-3 py-2 border rounded-md"
                    [ngClass]="{'border-red-500': hasError('accountType', 'required')}"
                >
                    <option value="">Seleccione el tipo de cuenta</option>
                    <option value="Corriente">Corriente</option>
                    <option value="Ahorros">Ahorros</option>
                </select>
                <div class="text-red-500 text-sm mt-1" *ngIf="hasError('accountType', 'required')">
                    El tipo de cuenta es obligatorio
                </div>
            </div>
        </div>

        <!-- Campos Opcionales -->
        <div class="mb-4 flex flex-col gap-6 xl:flex-row">
            <!-- Sucursal -->
            <div class="w-full xl:w-1/2">
                <label for="branch" class="block text-gray-700 font-bold mb-2">
                    Sucursal
                </label>
                <input
                    type="text"
                    id="branch"
                    formControlName="branch"
                    class="w-full px-3 py-2 border rounded-md"
                    placeholder="Ingrese la sucursal (opcional)"
                >
            </div>

            <!-- Teléfono -->
            <div class="w-full xl:w-1/2">
                <label for="phone" class="block text-gray-700 font-bold mb-2">
                    Teléfono
                </label>
                <input
                    type="text"
                    id="phone"
                    formControlName="phone"
                    class="w-full px-3 py-2 border rounded-md"
                    [ngClass]="{'border-red-500': hasError('phone', 'pattern')}"
                    placeholder="Ingrese el teléfono (10 dígitos)"
                >
                <div class="text-red-500 text-sm mt-1" *ngIf="hasError('phone', 'pattern')">
                    El teléfono debe contener exactamente 10 dígitos
                </div>
            </div>
        </div>

        <!-- Dirección -->
        <div class="mb-4">
            <label for="address" class="block text-gray-700 font-bold mb-2">
                Dirección
            </label>
            <input
                type="text"
                id="address"
                formControlName="address"
                class="w-full px-3 py-2 border rounded-md"
                placeholder="Ingrese la dirección del banco (opcional)"
            >
        </div>

        <!-- Botones -->
        <div class="flex justify-end mt-4 gap-4">
            <button
                type="submit"
                [disabled]="bankForm.invalid || submitting"
                class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {{ isEditing ? 'Actualizar' : 'Guardar' }}
            </button>
        </div>
    </form>
</div>